import { render, staticRenderFns } from "./CAppSelector.vue?vue&type=template&id=893b1652&scoped=true&"
import script from "./CAppSelector.vue?vue&type=script&lang=js&"
export * from "./CAppSelector.vue?vue&type=script&lang=js&"
import style0 from "./CAppSelector.vue?vue&type=style&index=0&id=893b1652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893b1652",
  null
  
)

export default component.exports